import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fas fa-baseball-ball"
}
const _hoisted_2 = {
  key: 1,
  class: "fas fa-table-tennis"
}
const _hoisted_3 = { key: 2 }


export default /*#__PURE__*/_defineComponent({
  props: {
    playerId: null,
    server: null,
    receiver: null
  },
  emits: ['set-server'],
  setup(__props: any, { emit }) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["bg-gray-300 px-3 py-2 rounded-md w-10", { 'bg-yellow-500': __props.server === __props.playerId, 'bg-red-500': __props.receiver === __props.playerId }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('set-server', __props.playerId)))
  }, [
    (__props.server === __props.playerId)
      ? (_openBlock(), _createElementBlock("i", _hoisted_1))
      : (__props.receiver === __props.playerId)
        ? (_openBlock(), _createElementBlock("i", _hoisted_2))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, "-"))
  ], 2))
}
}

})